import React from 'react'
import Sidebar from './Sidebar'

const DashboardFooter = () => {
  return (
    <div>
      
    </div>
  )
}

export default DashboardFooter
